import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {
	FunctionalCapacitiesService,
	FunctionalCapacity, FunctionalCapacityCreateForm, FunctionalCapacityGroupDiagram,
	FunctionalCapacityIcon
} from "../../../../../services/back/functional-capacities.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DesignSystemModule} from "../../../../design-system/design-system.module";
import {ChipsModule} from "../../../../global/chips/chips/chips.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf, NgIf} from "@angular/common";

export interface AddCapacityDialogData {
	id: string;
	group: string;
	tenantId: string;
	tenantFunctionalCapacitiesGroups: FunctionalCapacityGroupDiagram[];
}

@Component({
  selector: 'app-add-capacity-dialog',
	imports: [
		DesignSystemModule,
		ChipsModule,
		TranslateModule,
		ReactiveFormsModule,
		NgIf,
		NgForOf
	],
  templateUrl: './add-capacity-dialog.component.html',
  styleUrl: './add-capacity-dialog.component.scss'
})
export class AddCapacityDialogComponent implements OnInit {
	createFunctionalCapacityFormGroup: FormGroup = new FormGroup({
		group: new FormControl<FunctionalCapacity | null>(null, [Validators.required]),
		name: new FormControl<string | null>(null, [Validators.required]),
	});

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AddCapacityDialogData,
		private dialogRef: MatDialogRef<AddCapacityDialogComponent>,
		private functionalCapacitiesService: FunctionalCapacitiesService
	) {}

	ngOnInit(): void {
		if (this.data) {
			this.createFunctionalCapacityFormGroup.patchValue({
				group: {
					groupId: this.data.id,
					name: this.data.group
				}
			});
		}
	}

	onCancel(): void {
		this.dialogRef.close({ result: false, type: 'create' });
	}

	onSave(): void {
		if (this.createFunctionalCapacityFormGroup.valid) {
			const form: FunctionalCapacityCreateForm = {
				groupId: this.createFunctionalCapacityFormGroup.get('group')!.value.groupId,
				name: this.createFunctionalCapacityFormGroup.get('name')!.value
			};

			this.functionalCapacitiesService.createFunctionalCapacity(this.data.tenantId, form)
				.subscribe(result => {
					this.dialogRef.close({ result: !!result, type: 'create' });
				});
		}
	}
}
